import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalFaqItem, PortalFaqItemWriteInput } from "@colab/shared";

export type UpdateFaqItemInput = {
  id: string;
  input: PortalFaqItemWriteInput;
};

// PATCH /api/admin/portal-content/faq/:id
//
// Pessimistic. Invalidates portalContent.faqAdmin + portalContent.faqPublic.
export function useUpdateFaqItem() {
  const queryClient = useQueryClient();
  return useMutation<
    { id: string; row: PortalFaqItem },
    ApiClientError,
    UpdateFaqItemInput
  >({
    mutationFn: ({ id, input }) =>
      apiFetch<{ id: string; row: PortalFaqItem }>(
        `/admin/portal-content/faq/${encodeURIComponent(id)}`,
        { method: "PATCH", body: JSON.stringify(input) },
      ),
    onError: (err) => {
      toast.error(err.message ?? "Failed to update FAQ item");
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.faqAdmin(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.faqPublic(),
      });
    },
  });
}
